var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 4.00033C14.6667 3.26699 14.0667 2.66699 13.3333 2.66699H2.66666C1.93333 2.66699 1.33333 3.26699 1.33333 4.00033V12.0003C1.33333 12.7337 1.93333 13.3337 2.66666 13.3337H13.3333C14.0667 13.3337 14.6667 12.7337 14.6667 12.0003V4.00033ZM13.3333 4.00033L8 7.33366L2.66666 4.00033H13.3333ZM13.3333 12.0003H2.66666V5.33366L8 8.66699L13.3333 5.33366V12.0003Z",
    fill: "#212121"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.d0ac7974.svg";
export { ForwardRef as ReactComponent };